module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-04.ebbca70.jpg";